import React from 'react';
import styles from './Home.module.css';

function Home() {
    return (
        <div className={styles.homeContainer}>
            <div className={styles.introSection}>
                <h1 className={styles.pageTitle}>
                    Salut, sunt Marius Onea, alias
                    <span className={styles.spacer}></span>
                    <span className={styles.omdBox}>
                        <span className={styles.red}>O</span>
                        <span className={styles.blue}>M</span>
                        <span className={styles.green}>D</span>
                    </span>
                    <span className={styles.spacer}></span>!
                </h1>
                <p className={styles.introText}>
                    Inginer Software Full-Stack și Analist QA Automation, specializat în proiectarea de arhitecturi complexe și sisteme scalabile. Pasiunea mea constă în dezvoltarea de platforme de producție robuste, crearea de motoare logice personalizate și optimizarea fluxurilor prin integrarea inteligenței artificiale.
                </p>
                <p className={styles.introText}>
                    Te invit să explorezi portofoliul meu pentru a descoperi evoluția tehnică de la aplicații web interactive la ecosisteme Client-Server avansate, construite cu rigoare analitică și bazate predominant pe stiva MERN.
                </p>
                <div className={styles.ctaButtons}>
                    <a href='/projects' className={styles.ctaButton}>
                        Vezi Proiecte
                    </a>
                    <a href='/about' className={styles.ctaButton}>
                        Despre Mine
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Home;